import React from 'react';

export default function ExportPurchases() {
	return (
		<>
			<div className="comp-heading">
				<div className="row">
					<div className="col-lg-4">
						<label>Export Purchases</label>
					</div>
				</div>
			</div>
			<br />
			Export Purchases
		</>
	);
}
